import React, { createContext, useContext, useState } from 'react';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [selectedCabin, setSelectedCabin] = useState(null);
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [guests, setGuests] = useState(2);
  const [bookingStep, setBookingStep] = useState(1);
  const [bookingData, setBookingData] = useState(null);

  const resetBooking = () => {
    setSelectedCabin(null);
    setDateRange({ from: null, to: null });
    setGuests(2);
    setBookingStep(1);
    setBookingData(null);
  };

  const calculateTotal = () => {
    if (!selectedCabin || !dateRange.from || !dateRange.to) return 0;
    const nights = Math.ceil((dateRange.to - dateRange.from) / (1000 * 60 * 60 * 24));
    return nights * selectedCabin.price_per_night;
  };

  const getNights = () => {
    if (!dateRange.from || !dateRange.to) return 0;
    return Math.ceil((dateRange.to - dateRange.from) / (1000 * 60 * 60 * 24));
  };

  const value = {
    selectedCabin,
    setSelectedCabin,
    dateRange,
    setDateRange,
    guests,
    setGuests,
    bookingStep,
    setBookingStep,
    bookingData,
    setBookingData,
    resetBooking,
    calculateTotal,
    getNights
  };

  return (
    <BookingContext.Provider value={value}>
      {children}
    </BookingContext.Provider>
  );
};

export default BookingContext;
